export default "__VITE_ASSET__BpEyLiP$__"